import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/custom_post_list_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  keyword: {
    model_name: 'CustomPostList',
    column_type: 'string',
    column_name: 'title',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: true, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
    'custom_post_lists_posts_attributes': { required: false, disabledUpdate: false },
  },
  'custom_post_lists_posts_attributes': {
    'id': { required: false, disabledUpdate: true },
    'post_id': { required: false, disabledUpdate: true },
    'position': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('CustomPostList', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('CustomPostList', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
